module.exports = __webpack_public_path__ + "static/media/29BDOS16.fbc74995.jpg";